const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const isValidUuid = (uuid: string): boolean => {
  return uuidRegex.test(uuid);
};

const uuidv4 = () => crypto.randomUUID();

export { isValidUuid, uuidv4 };
